/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, inject } from '@angular/core';
import { MatDialogRef, CDS_POPUP_DATA, CdsPopupModule } from '@cds/ng-web-components/popup';
import { CdsButtonConfig } from '@cds/ng-core/button';
import { CdsButtonModule } from '@cds/ng-web-components/button';
import { CdsProgressModule } from '@cds/ng-web-components/progress';
import { CdsLanguageModule } from '@cds/ng-core/lang';

@Component({
  selector: 'app-user-agreement-popup',
  templateUrl: './user-agreement-popup.component.html',
  styleUrls: ['./user-agreement-popup.component.scss'],
  imports: [CdsPopupModule, CdsButtonModule, CdsProgressModule, CdsLanguageModule],
})
export class UserAgreementPopupComponent {
  private dialogRef = inject<MatDialogRef<UserAgreementPopupComponent>>(MatDialogRef);
  data = inject<{
    title: string;
    message: string;
    cancel: string;
    continue: string;
    type: string;
    params: any;
    actionRight: boolean;
  }>(CDS_POPUP_DATA);

  disagreeButtonConfig: CdsButtonConfig = { size: 'sm', style: 'secondary' };
  agreeButtonConfig: CdsButtonConfig = { size: 'sm' };

  constructor() {
    const data = this.data;

    if (data.params) this.params = data.params;
  }
  params = {};

  agree() {
    this.dialogRef.close({ agree: true });
  }
  disagree() {
    this.dialogRef.close({ agree: false });
  }
}
